import { render, staticRenderFns } from "./nowdate.vue?vue&type=template&id=a7283bc0"
import script from "./nowdate.vue?vue&type=script&lang=js"
export * from "./nowdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports